import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { selectUser } from "../redux/slices/authSlice";
import { SubscriptionRequiredModal } from "../components/SubscriptionRequiredModal/SubscriptionRequiredModal";
import { FLEETRIFYROUTEPATH } from "./routesPath";

const ProtectedRoute = () => {
  const token = Cookies.get("token");
  const user = useSelector(selectUser);
  const location = useLocation();

  const [searchParams] = useSearchParams()
  const queryParam = searchParams.get("view")
  const tabParam = searchParams.get("tab")

  const isPublicView =
    queryParam === "password-change" || queryParam === "password-reset";

  if (!token && !isPublicView) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // user.company.subscription_status comes from /login (and is kept fresh by
  // useSubscriptionGuard refetching /me) — this is the one field confirmed
  // against a real API response; both /company/get-company's `active_subscription`
  // and the subscriptions-list endpoint's shape were unverified guesses that
  // caused false blocks/bypasses in both directions.
  const isSubscriptionActive = user?.company?.subscription_status === "active";

  // Allow access to settings page with subscription tab without blocking modal
  const isSubscriptionSettingsPage =
    location.pathname === FLEETRIFYROUTEPATH.SETTINGS && tabParam === "subscription";

  // Show subscription modal only if:
  // 1. There is an authenticated user (the only way to reach here without a
  //    token is the password-change/password-reset public view, which must
  //    render unblocked)
  // 2. Subscription is not active
  // 3. Not on the subscription settings page
  if (token && !isSubscriptionActive && !isSubscriptionSettingsPage) {
    return (
      <>
        <SubscriptionRequiredModal isOpen={!isSubscriptionActive} />
        <div className="pointer-events-none opacity-50">
          <Outlet />
        </div>
      </>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
